// extracted by mini-css-extract-plugin
module.exports = {"title-default":"Title_title-default__1MgeD","title-small":"Title_title-small__zsvZS"};